import { render, staticRenderFns } from "./UIDLabelPrint.vue?vue&type=template&id=5da20d5e"
import script from "./UIDLabelPrint.vue?vue&type=script&lang=js"
export * from "./UIDLabelPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports